module.exports = __webpack_public_path__ + "img/building-active.2b2eb710.svg";